import React, { FC } from 'react';
import { productImage, redAlertIcon, yellowAlertIcon } from 'assets/images';
import styled from 'styled-components';
import {
  Box,
  Heading,
  Image,
  Text,
  Button,
  Flex,
} from '@resideo/blueprint-react';
import { useTranslation } from 'react-i18next';

const StyledBorder = styled(Box)`
  border: 2px solid ${({ theme }) => theme.colors.lightenGray};
`;

const MonitorItems: FC<any> = ({ data }) => {
  const q = new Date();
  const m = q.getMonth() + 1;
  const d = q.getDay();
  const y = q.getFullYear();
  const date = new Date(y, m, d);
  const planDate = new Date(data.expiryDate);
  const isExpired = date > planDate;

  const { t } = useTranslation();

  return (
    <Flex
      alignItems='center'
      flexDirection={['column', 'column', 'row', 'row']}>
      <Box display='flex' alignItems='center' paddingRight='xLarge'>
        <Box display='flex' alignItems='center'>
          <StyledBorder
            flex={1}
            height={['5rem', '5.5rem', '6rem', '6.25rem']}
            width={['5rem', '6rem', '7rem', '7.1875rem']}
            marginRight='medium'
            display='flex'
            justifyContent='center'
            alignItems='center'>
            <Image
              maxHeight={['4.375rem', '5rem', '5.9375rem', '5.9375rem']}
              src={productImage}
              alt='product'
            />
          </StyledBorder>
        </Box>
        <Box
          flex={1}
          display='flex'
          alignItems='center'
          justifyContent='space-between'
          paddingLeft={[
            data.status === 'continued' ? '0.5rem' : '0rem',
            data.status === 'continued' ? '0.5rem' : '0.8rem',
            data.status === 'continued' ? '0.5rem' : '1rem',
            data.status === 'continued' ? '0.5rem' : '4rem',
          ]}>
          <Box>
            <Heading
              fontSize={['small', 'small', 'medium', 'medium']}
              fontWeight='bold'
              color='textHeading'>
              {data.title || ''}
            </Heading>
            <Text color='black' fontSize='small' paddingTop='small'>
              DeviceID #{data.deviceId || ''}
            </Text>
            <Text
              color='gray'
              fontSize='small'
              fontWeight='500'
              paddingTop='xSmall'
              paddingBottom='small'>
              {data.deviceNumber || ''}
            </Text>
            <Box display='flex' alignItems='center'>
              <Image
                width='1rem'
                src={isExpired ? redAlertIcon : yellowAlertIcon}
                alt='alert'
              />
              <Text fontSize='medium' fontWeight='400' marginLeft='small'>
                {!isExpired ? 'Expired' : 'Expires'} {data.expiryDate || ''}
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
      {data.price && (
        <Box
          flex={['100%', '100%', '50%', '50%']}
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          paddingX={['0', '0', 'small', 'medium']}
          paddingTop={['medium']}>
          <Heading
            paddingRight={['small', 'small', '0', '0']}
            paddingLeft={['0', '0', 'large', 'xLarge']}
            fontSize='large'>
            ${data.price.toFixed(2)}
          </Heading>
          <Button
            backgroundColor='primary'
            color='white'
            paddingX='3.125rem'
            paddingY='0.75rem'>
            {t('add')}
          </Button>
        </Box>
      )}
      {data.status === 'continued' && (
        <Box
          paddingTop={['medium', 'medium', '0', '0']}
          display='flex'
          justifyContent='flex-end'>
          <Button>{t('refreshMonitor.continueToCart')}</Button>
        </Box>
      )}
    </Flex>
  );
};

export default MonitorItems;
